class PDPCustomText extends HTMLElement {
  NAME = 'PDPCustomText'
  abortController
  customTextInput
  form
  inputs
  formObj
  inputDict
  productForm
  inBundle
  required
  variantId
  disabled

  constructor() {
    super();
    /* console.info(`${this.NAME} > constructor`); */
    this.customTextInput = this.querySelector('custom-text-input');
    this.form = this.querySelector('form');
    this.inputs = this.form.firstElementChild.querySelectorAll('input');
    this.productForm = document.querySelector('product-form form[action="/cart/add"]');
    const data = new FormData(this.form);
    this.formObj = Object.fromEntries(data.entries());
  }

  connectedCallback() {
    /* console.info(`${this.NAME} > connectedCallback`); */
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    const idInput = document.querySelector('[data-element="id-input"]');
    //
    if (idInput) {
      const mutationCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            /* console.log(mutation.target.value, mutation.oldvalue); */
            this.updateVariant(mutation.target.value);
          }
        }
      };
      this.observer = new MutationObserver(mutationCallback);
      this.observer.observe(idInput, { attributes: true });
    }
    //
    this.updateVariant(new URLSearchParams(window.location.search).get('variant'));
    //
    this.form.addEventListener('change', () => this.onChange(), { signal });
    //
    setTimeout(() => {
      this.inputDict = {};
      this.customTextInput.inputs.forEach((input, i) => {
        input.addEventListener('input', (e) => this.onChange(e), { signal });
        const existingInput = this.productForm.querySelector(`input[name="properties[Line ${i + 1}]"]`)
        if (!existingInput) {
          this.inputDict[input.name] = this.createInput('text', `properties[Line ${i + 1}]`);
          this.productForm.appendChild(this.inputDict[input.name]);
        } else {
          this.inputDict[input.name] = existingInput;
        }
      });
      //
      if (this.inBundle) {
        const staticBundleText = this.productForm.querySelector('input[name="properties[_static_bundle_custom_text]"]');
        if (!staticBundleText) {
          this.inputDict['bundle-custom-text'] = this.createInput('text', 'properties[_static_bundle_custom_text]');
          this.productForm.appendChild(this.inputDict['bundle-custom-text']);
        } else {
          this.inputDict['bundle-custom-text'] = staticBundleText;
        }
      }
      //
      if (this.required) {
        this.onChange({ target: { name: 'custom_text_1' }});
      } else {
        this.onChange();
      }
    }, 20);

  }

  disconnectedCallback() {
    this.abortController.abort();
    this.abortController = null;
    this.observer.disconnect();
    this.observer = null;
  }

  static get observedAttributes() {
    return ['data-in-bundle', 'data-required', 'data-variant-id', 'data-disabled'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-in-bundle') {
      this.inBundle = newValue === 'true';
    }
    //
    if (name === 'data-required') {
      this.required = newValue === 'true';
      setTimeout(() => {
        this.customTextInput.dataset.show = this.required;
      }, 20);
    }
    //
    if (name === 'data-variant-id') {
      this.variantId = newValue;
    }
    //
    if (name === 'data-disabled' && oldValue !== newValue) {
      this.disabled = newValue === 'true';
      if (this.disabled === 'true') {
        this.inputs.forEach(input => input.disabled = true);
        this.customTextInput.inputs?.forEach(input => input.disabled = true);
        for (const key in this.inputDict) {
          if (Object.prototype.hasOwnProperty.call(this.inputDict, key)) {
            this.inputDict[key].value = '';
          }
        }
      } else {
        this.inputs?.forEach(input => input.disabled = false);
        this.customTextInput.inputs?.forEach(input => input.disabled = false);
        if (this.inputDict) {
          this.onChange({ target: { name: 'custom_text_1' }});
          for (const key in this.inputDict) {
            if (Object.prototype.hasOwnProperty.call(this.inputDict, key)) {
              this.onChange({ target: { name: key }});
            }
          }
        }
      }
    }
  }

  updateVariant(newVariant) {
    if (!newVariant) newVariant = 'default';
    this.dataset.disabled = !(newVariant === this.variantId || (newVariant == 'default' && this.dataset.default === 'true'));
    if (this.dataset.disabled === 'false' && !this.required && this.formObj.add_custom_text === 'no') {
      this.productForm.parentNode.style.pointerEvents = 'all';
      this.productForm.style.opacity = '1';
    }
  }

  onChange(e) {
    if (this.disabled) {
      setTimeout(() => {
        const allDisabled = Array.from(document.querySelectorAll('pdp-custom-text')).map(e => e.dataset.disabled === 'true').reduce((a,b) => !a ? a : b);
        if (allDisabled) {
          this.productForm.parentNode.style.pointerEvents = 'all';
          this.productForm.style.opacity = '1';
        }
      }, 0);
      return;
    }
    const data = new FormData(this.form);
    this.formObj = Object.fromEntries(data.entries());
    /* console.info(`${this.NAME} > onChange`, this.formObj, e); */
    //
    if (!this.required && this.formObj.add_custom_text === 'yes' && this.customTextInput.dataset.show === 'false') {
      /* console.log("this.formObj.add_custom_text === 'yes"); */
      this.customTextInput.dataset.show = true;
      this.customTextInput.dataset.required = true;
      this.productForm.parentNode.style.pointerEvents = 'none';
      this.productForm.style.opacity = '0.65';
      if (this.inBundle) this.inputDict['bundle-custom-text'].disabled = false;
    } else if (!this.required && this.formObj.add_custom_text === 'no' && this.customTextInput.dataset.show === 'true') {
      /* console.log("!this.required && this.formObj.add_custom_text === 'no' etc"); */
      this.customTextInput.dataset.show = false;
      this.customTextInput.dataset.required = false;
      this.customTextInput.inputs.forEach(input => {
        input.value = '';
        this.inputDict[input.name].disabled = true;
      });
      if (this.inBundle) this.inputDict['bundle-custom-text'].disabled = true;
      this.productForm.parentNode.style.pointerEvents = 'all';
      this.productForm.style.opacity = '1';
    }

    if (e) {
      //console.log('this.inputDict', this.inputDict);

      let addToCartEnabled = true;
      this.customTextInput.inputs.forEach((input, i) => {
        //console.log("kj foreach input", input);
        let propertyInput = this.inputDict[input.name];
        propertyInput.disabled = false;
        propertyInput.value = input.value;
        if (input.hidden) {
          return;
        }

        if (!input.value.length) {
          addToCartEnabled = false;
        }
      });

      if (addToCartEnabled) {
        this.productForm.parentNode.style.pointerEvents = 'all';
        this.productForm.style.opacity = '1';
      } else {
        this.productForm.parentNode.style.pointerEvents = 'none';
        this.productForm.style.opacity = '0.65';
      }
    }
    //
    if (this.inBundle) {
      if (this.formObj.add_custom_text === 'yes' || this.required) {
        let updatedValues = [];
        this.customTextInput.inputs.forEach(input => {
          if (input.value.length) {
            updatedValues.push(input.value);
          }
          this.inputDict['bundle-custom-text'].disabled = false;
          this.inputDict['bundle-custom-text'].value = updatedValues.join('|');
        });
      } else {
        this.inputDict['bundle-custom-text'].value = '';
      }
    }
  }

  createInput(type, name) {
    const input = document.createElement('INPUT');
    input.hidden = true;
    input.disabled = true;
    input.type = type;
    input.name = name;
    return input;
  }
}

customElements.define('pdp-custom-text', PDPCustomText);
